var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('dictionary.security-alerts')}}),_c('page-body',[_c('list',{attrs:{"id":"security-alerts-list"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }